import { useCallback, useEffect, useRef, useState } from "react";

const VISIBLE_MS = 2600;

/**
 * "Saved" / "Password updated" confirmations: shown briefly, then gone, so a
 * stale one never sits next to a form the user has since edited again.
 */
export const useFlash = (): { shown: boolean; flash: () => void; clear: () => void } => {
  const [shown, setShown] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const clear = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setShown(false);
  }, []);

  const flash = useCallback(() => {
    clearTimeout(timeoutRef.current);
    setShown(true);
    timeoutRef.current = setTimeout(() => setShown(false), VISIBLE_MS);
  }, []);

  return { shown, flash, clear };
};
